export function removeNullProperties<T extends object>(obj: T): T {
  const noNull = Object.entries(obj).filter(([k, v]) => v !== null)
  return Object.fromEntries(noNull) as T
}
